export const EXPANDED_STATE_COOKIE = '_cookie_consent_expanded_state'
